<template>
    <div class="optionboard-phonemic-vowel">
        <div class="optionboard-phonemic-vowel__feature-type">
            <span class="optionboard-phonemic-vowel__feature-label">DİLİN DEVİNİMİ</span>
            <div class="optionboard-phonemic-vowel__feature-options">
                <BtnOptionPhonemicVowel
                    v-for="backnessOption in backnessOptions"
                    featureType="backness"
                    :optionSlug="backnessOption"
                    :optionText="$t('vowel.backness.' + backnessOption)"
                    @click="selectBackness(backnessOption)" />
            </div>
        </div>

        <div class="optionboard-phonemic-vowel__feature-type">
            <span class="optionboard-phonemic-vowel__feature-label">ÇENE AÇISI</span>
            <div class="optionboard-phonemic-vowel__feature-options">
                <BtnOptionPhonemicVowel
                    v-for="heightOption in heightOptions"
                    featureType="height"
                    :optionSlug="heightOption"
                    :optionText="$t('vowel.height.' + heightOption)"
                    @click="selectHeight(heightOption)" />
            </div>
        </div>

        <div class="optionboard-phonemic-vowel__feature-type">
            <span class="optionboard-phonemic-vowel__feature-label">DUDAK DURUMU</span>
            <div class="optionboard-phonemic-vowel__feature-options">
                <BtnOptionPhonemicVowel
                    v-for="roundednessOption in roundednessOptions"
                    featureType="roundedness"
                    :optionSlug="roundednessOption"
                    :optionText="$t('vowel.roundedness.' + roundednessOption)"
                    @click="selectRoundedness(roundednessOption)" />
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionPhonemicVowel from '@/components/BtnOptionPhonemicVowel.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionPhonemicVowel,
        },

        props: {
            backnessOptions: {
                type: Array,
                default: ["front", "central", "back"]
            },
            heightOptions: {
                type: Array,
                default: ["close", "open-mid", "open"],
            },
            roundednessOptions: {
                type: Array,
                default: ["unrounded", "rounded"],
            },
        },

        methods: {
            selectBackness(answerDataBackness){
                this.$store.commit('setAnswerDataBackness', answerDataBackness);
            },

            selectHeight(answerDataHeight){
                this.$store.commit('setAnswerDataHeight', answerDataHeight);
            },

            selectRoundedness(answerDataRoundedness){
                this.$store.commit('setAnswerDataRoundedness', answerDataRoundedness);
            }
        }
    };
</script>

<style scoped src="@/css/components/optionboard-phonemic-vowel.css"></style>